module.exports = __webpack_public_path__ + "img/ring.b1d12eba.png";